import { useState } from "react";
// import { Helmet } from "react-helmet";

import SEO from "../components/SEO";

import { Flex, Spacer, useToast, VisuallyHidden } from "@chakra-ui/react";

import { Nav } from "../components/Nav";

// eslint-disable-next-line
import { jsonFile, nodeJs, text } from "../assets";

import ExportButton from "../components/ExportButton";

import { BrandPalette } from "./Color/BrandPalette";
import { AlertPalette } from "./Color/AlertPalette";

import ReactGA from "react-ga";

import {Adsense} from '@ctrl/react-adsense';

export const Color = () => {
  const jsonToCssVariables = require("json-to-css-variables");
  const toast = useToast();

  let files = [
    // JSON
    { id: 0, type: "json", img: jsonFile },
    // JS
    { id: 1, type: "js", img: nodeJs },
    // CSS Variables
    // { id: 2, type: "css", img: text },
  ];

  const [fileType, setFileType] = useState(0);

  var arr = {};
  var arrJs = { fonts: {}, color: {} };

  var myFonts = [];

  var finalOutput = [];

  const fetch = () => {
    let data = JSON.parse(localStorage.getItem("FontFamilies"));
    let data0 = JSON.parse(localStorage.getItem("FontVars"));
    let data1 = JSON.parse(localStorage.getItem("BrandPalette"));
    let data2 = JSON.parse(localStorage.getItem("AlertPalette"));

    for (let i = 0; i < data0.length; i++) {
      // fonFam: "Nunito"​​
      // fonHeight: "150"
      // fonSize: "9em"
      // fonSpacing: "8"
      // fonWeight: "100"

      let h1 = {
        fontFamily: data0[0].fonFam,
        fontSize: data0[0].fonSize,
        lineHeight: data0[0].fonHeight,
        letterSpacing: data0[0].fonSpacing,
        fontWeight: data0[0].fonWeight,
      };

      let h2 = {
        fontFamily: data0[1].fonFam,
        fontSize: data0[1].fonSize,
        lineHeight: data0[1].fonHeight,
        letterSpacing: data0[1].fonSpacing,
        fontWeight: data0[1].fonWeight,
      };

      let h3 = {
        fontFamily: data0[2].fonFam,
        fontSize: data0[2].fonSize,
        lineHeight: data0[2].fonHeight,
        letterSpacing: data0[2].fonSpacing,
        fontWeight: data0[2].fonWeight,
      };

      let h4 = {
        fontFamily: data0[3].fonFam,
        fontSize: data0[3].fonSize,
        lineHeight: data0[3].fonHeight,
        letterSpacing: data0[3].fonSpacing,
        fontWeight: data0[3].fonWeight,
      };

      let h5 = {
        fontFamily: data0[4].fonFam,
        fontSize: data0[4].fonSize,
        lineHeight: data0[4].fonHeight,
        letterSpacing: data0[4].fonSpacing,
        fontWeight: data0[4].fonWeight,
      };

      let h6 = {
        fontFamily: data0[5].fonFam,
        fontSize: data0[5].fonSize,
        lineHeight: data0[5].fonHeight,
        letterSpacing: data0[5].fonSpacing,
        fontWeight: data0[5].fonWeight,
      };

      // arr = { h1, h2, h3, h4, h5, h6 };
      arrJs = { fonts: {}, color: {}, h1, h2, h3, h4, h5, h6 };
      // eslint-disable-next-line
      myFonts = [h1, h2, h3, h4, h5, h6];
    }

    // For HEADING CSS VARIABLES
    // for (let i = 0; i < data0.length; i++) {
    //   const options = {
    //     element: `--${data0[i].side[0]}`,
    //     pretty: true,
    //   };
    //   // let myH = data0[i].side[0];
    //   finalOutput.push(jsonToCssVariables(myFonts[i], options));
    //   // console.log(finalOutput);
    // }

    for (let i = 0; i < data.length; i++) {
      arr[data[i].cardName] = data[i].cardValue;
      arrJs.fonts[data[i].cardName] = data[i].cardValue;
    }

    for (let i = 0; i < data1.length; i++) {
      arr[data1[i].cardName] = data1[i].cardValue;
      arrJs.color[data1[i].cardName] = data1[i].cardValue;
    }

    arrJs.color.alert = {};
    for (let i = 0; i < data2.length; i++) {
      arr[data2[i].cardName] = data2[i].cardValue;
      arrJs.color.alert[data2[i].cardName] = data2[i].cardValue;
    }
  };

  const handleDownload = () => {
    fetch();

    ReactGA.event({
      category: "Button",
      action: "Download Button",
    });

    toast({
      title: `Successfully Exported theme.${files[fileType].type}`,
      status: "success",
      variant: "subtle",
      position: "top-right",
      duration: 3000,
      isClosable: true,
    });

    let output;

    if (files[fileType].type === "json" || files[fileType].type === "js") {
      output = JSON.stringify(arrJs, null, 2);
    }

    if (files[fileType].type === "css") {
      // const options = {
      //   element: ":root",
      //   pretty: true,
      // };
      // output = jsonToCssVariables(arr, options);

      const options = {
        element: ":root",
        pretty: true,
      };
      let myFinal = jsonToCssVariables(arr, options);

      output = [myFinal, finalOutput];

      // output = finalOutput;
    }

    // Download it
    const blob = new Blob([output]);
    const fileDownloadUrl = URL.createObjectURL(blob);

    // Creating the Link Element to download
    const link = document.createElement("a");
    link.href = fileDownloadUrl;
    link.setAttribute("download", `theme.${files[fileType].type}`);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <main>
      {/* SEO */}

      <SEO
        title="Color Palette Creator | Felco ThemeGen"
        desc="Create Color Palettes and Brand Themes for Design Systems"
        keywords="ThemeGen, Themeit, themify, Design System, create Design Systems, Style guide, design system software, Theme Generator, Generate Themes, theme.js, golden ratio, color, color-palette, color palette generator, brand color, color scheme, scheme color,create color schemes, color theme, color palette, create color palette, create color theme, color theme, color palettes, color combinations, color, colors, palettes, hex color palette, color combination, color names, web color schemes, pretty colors"
        url="https://themegen.netlify.app/color-palette"
        type="website"
        img="https://felcoimg.netlify.app/img/color-palette.png"
      >
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6991856412998100"
      crossorigin="anonymous"></script>
      </SEO>
      {/* 
      <Helmet>
        <title>Color Palette Creator | Felco ThemeGen</title>
        <meta
          name="title"
          content="Color Palette Generator | Felco ThemeGen"
        ></meta>
        <meta name="description" content="Create Color Palettes and Themes" />
        <meta
          name="keywords"
          content="ThemeGen, Themeit, themify, Theme Generator, Generate Themes, theme.js, golden ratio, color, color-palette, color palette generator, palette generator"
        />
        <link
          rel="canonical"
          href="https://themegen.netlify.app/color-palette"
        />

        {/* Open Graph / Facebook 
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://themegen.netlify.app/color-palette"
        />
        <meta
          property="og:title"
          content="Color Palette Generator | Felco ThemeGen"
        />
        <meta
          property="og:description"
          content="Generate Color Palettes and Themes"
        />
        {/* <meta property="og:image" content="" /> 

        {/* Twitter 
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://themegen.netlify.app/color-palette"
        />
        <meta
          property="twitter:title"
          content="Color Palette Generator | Felco ThemeGen"
        />
        <meta
          property="twitter:description"
          content="Generate Color Palettes and Themes"
        />
        {/* <meta property="twitter:image" content="" /> *
      </Helmet> */}

      <Nav title="Color Palette" />

      <VisuallyHidden>
        Felco Themegen | Color Palette is a color palette and color scheme
        creator for Design Systems, create hex|rgb|hsl color palettes and export
        the Design System in js, json for your Brands or personal project.
      </VisuallyHidden>
      <Adsense
        client="ca-pub-6991856412998100"
        slot="1182937771" 
      />

      <BrandPalette />
      <AlertPalette />

      <Flex>
        <Spacer />
        <ExportButton
          handleDownload={handleDownload}
          files={files}
          fileType={fileType}
          setFileType={setFileType}
        />
      </Flex>
    </main>
  );
};
